export default "__VITE_ASSET__d40fff42__"